module.exports = __webpack_public_path__ + "img/wap_02.6a9523ae.png";